export default __webpack_public_path__ + "static/media/Picture3.7f5cf0b7.png";